// extracted by mini-css-extract-plugin
module.exports = {"inputLabel":"inputLabel-2Ty-z","input":"input-33zun","loginButton":"loginButton-w-ORC"};